import React from 'react'
import { Route, Switch } from 'react-router'
import Tracing from './Tracing'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={Tracing} />
    </Switch>
)

export default Components
